import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["disabled"]


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
  variant: { type: String, default: "primary" },
  customClass: { type: String, default: "" },
  isShow: { type: Boolean, default: true },
  disabled: { type: Boolean, default: false },
  isRouterLink: { type: Boolean, default: false },
  to: {
    type: Object as any,
    default() {
      return {}
    },
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!__props.isRouterLink)
    ? _withDirectives((_openBlock(), _createElementBlock("button", {
        key: 0,
        class: _normalizeClass(`btn ${__props.variant}-btn ${__props.disabled ? 'disabled' : ''} ${__props.customClass}`),
        disabled: __props.disabled
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1)), [
        [_vShow, __props.isShow]
      ])
    : _withDirectives((_openBlock(), _createBlock(_component_router_link, {
        key: 1,
        to: __props.to,
        class: _normalizeClass(`btn ${__props.variant}-btn ${__props.customClass} ${__props.disabled ? 'disabled' : ''}`),
        tag: "button"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["to", "class"])), [
        [_vShow, __props.isShow]
      ])
}
}

})